<template>
  <q-panel class="login-page">
    <div class="login-header">
      <img
        :src="logo"
        alt="Atrvasa"
        width="200px"
      >
    </div>
    <h4>{{ this.$qt('loginPage.header') }}</h4>
    <div class="login-form">
      <q-form
        ref="loginForm"
        :model="ruleForm"
        :rules="rules"
        :label-position="labelPosition"
        labq-width="120px"
      >
        <q-form-item
          prop="username"
        >
          <q-input
            v-model="ruleForm.username"
            :placeholder="this.$qt('loginPage.username')"
          />
        </q-form-item>
        <q-form-item
          prop="password"
        >
          <q-input
            v-model="ruleForm.password"
            type="password"
            :placeholder="this.$qt('loginPage.password')"
          />
        </q-form-item>
        <q-form-item
          prop="cultureName"
        >
          <q-model-selector
            v-model="ruleForm.cultureName"
            plugin="gausaka"
            delegate="getLanguages"
            display-field="name"
            value-field="cultureName"
            :placeholder="this.$qt('loginPage.language')"
            style="width: 100%"
          />
        </q-form-item>
        <q-form-item>
          <q-button
            size="mini"
            type="primary"
            style="width: 100%"
            @click="login"
          >
            {{ this.$qt('loginPage.login') }}
          </q-button>
        </q-form-item>
      </q-form>
      <!--      <h4>{{ this.$qt('loginPage.signUpHeader') }}</h4>-->
      <!--      <router-link :to="{ name: 'register'}">-->
      <!--        <q-button-->
      <!--          size="mini"-->
      <!--          type="info"-->
      <!--          style="width: 100%"-->
      <!--        >-->
      <!--          {{ this.$qt('loginPage.signUp') }}-->
      <!--        </q-button>-->
      <!--      </router-link>-->
    </div>
  </q-panel>
</template>

<script>
  import logo from '../../assets/images/logo-40.png';
  import icon from '../../assets/images/icon-30.jpg';


  export default {
    name: "Login",

    data() {
      return {
        logo: logo,
        icon: icon,
        labelPosition: 'right',
        ruleForm: {
          username: '',
          password: '',
          cultureName: 'en'
        },
        rules: {
          username: [
            {required: true, message: this.$qt('loginPage.usernameValidation.required'), trigger: 'blur'},
          ],
          password: [
            {required: true, message: this.$qt('loginPage.passwordValidation.required'), trigger: 'blur'}
          ]
        },
        jscd: {
          screen: 'screenSize',
          browser: 'browser',
          browserVersion: 'version',
          browserMajorVersion: 'majorVersion',
          mobile: 'mobile',
          os: 'os',
          osVersion: 'osVersion',
          cookies: 'cookieEnabled',
          flashVersion: 'flashVersion'
        }
      };
    },


    created() {
      this.xx();
    },

    methods: {
      xx() {

        let unknown = '-';

        // screen
        let screenSize = '';
        let width, height;
        if (screen.width) {
          width = (screen.width) ? screen.width : '';
          height = (screen.height) ? screen.height : '';
          screenSize += '' + width + " x " + height;
        }

        // browser
        let nVer = navigator.appVersion;
        let nAgt = navigator.userAgent;
        let browser = navigator.appName;
        let version = '' + parseFloat(navigator.appVersion);
        let majorVersion = parseInt(navigator.appVersion, 10);
        let nameOffset, verOffset, ix;

        // Opera
        if ((verOffset = nAgt.indexOf('Opera')) != -1) {
          browser = 'Opera';
          version = nAgt.substring(verOffset + 6);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
          }
        }
        // Opera Next
        if ((verOffset = nAgt.indexOf('OPR')) != -1) {
          browser = 'Opera';
          version = nAgt.substring(verOffset + 4);
        }
        // Edge
        else if ((verOffset = nAgt.indexOf('Edge')) != -1) {
          browser = 'Microsoft Edge';
          version = nAgt.substring(verOffset + 5);
        }
        // MSIE
        else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
          browser = 'Microsoft Internet Explorer';
          version = nAgt.substring(verOffset + 5);
        }
        // Chrome
        else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
          browser = 'Chrome';
          version = nAgt.substring(verOffset + 7);
        }
        // Safari
        else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
          browser = 'Safari';
          version = nAgt.substring(verOffset + 7);
          if ((verOffset = nAgt.indexOf('Version')) != -1) {
            version = nAgt.substring(verOffset + 8);
          }
        }
        // Firefox
        else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
          browser = 'Firefox';
          version = nAgt.substring(verOffset + 8);
        }
        // MSIE 11+
        else if (nAgt.indexOf('Trident/') != -1) {
          browser = 'Microsoft Internet Explorer';
          version = nAgt.substring(nAgt.indexOf('rv:') + 3);
        }
        // Other browsers
        else if ((nameOffset = nAgt.lastIndexOf(' ') + 1) < (verOffset = nAgt.lastIndexOf('/'))) {
          browser = nAgt.substring(nameOffset, verOffset);
          version = nAgt.substring(verOffset + 1);
          if (browser.toLowerCase() == browser.toUpperCase()) {
            browser = navigator.appName;
          }
        }
        // trim the version string
        if ((ix = version.indexOf(';')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(' ')) != -1) version = version.substring(0, ix);
        if ((ix = version.indexOf(')')) != -1) version = version.substring(0, ix);

        majorVersion = parseInt('' + version, 10);
        if (isNaN(majorVersion)) {
          version = '' + parseFloat(navigator.appVersion);
          majorVersion = parseInt(navigator.appVersion, 10);
        }

        // mobile version
        let mobile = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(nVer);

        // cookie
        let cookieEnabled = (navigator.cookieEnabled) ? true : false;

        if (typeof navigator.cookieEnabled == 'undefined' && !cookieEnabled) {
          document.cookie = 'testcookie';
          cookieEnabled = (document.cookie.indexOf('testcookie') != -1) ? true : false;
        }

        // system
        let os = unknown;
        let clientStrings = [
          {s: 'Windows 10', r: /(Windows 10.0|Windows NT 10.0)/},
          {s: 'Windows 8.1', r: /(Windows 8.1|Windows NT 6.3)/},
          {s: 'Windows 8', r: /(Windows 8|Windows NT 6.2)/},
          {s: 'Windows 7', r: /(Windows 7|Windows NT 6.1)/},
          {s: 'Windows Vista', r: /Windows NT 6.0/},
          {s: 'Windows Server 2003', r: /Windows NT 5.2/},
          {s: 'Windows XP', r: /(Windows NT 5.1|Windows XP)/},
          {s: 'Windows 2000', r: /(Windows NT 5.0|Windows 2000)/},
          {s: 'Windows ME', r: /(Win 9x 4.90|Windows ME)/},
          {s: 'Windows 98', r: /(Windows 98|Win98)/},
          {s: 'Windows 95', r: /(Windows 95|Win95|Windows_95)/},
          {s: 'Windows NT 4.0', r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
          {s: 'Windows CE', r: /Windows CE/},
          {s: 'Windows 3.11', r: /Win16/},
          {s: 'Android', r: /Android/},
          {s: 'Open BSD', r: /OpenBSD/},
          {s: 'Sun OS', r: /SunOS/},
          {s: 'Chrome OS', r: /CrOS/},
          {s: 'Linux', r: /(Linux|X11(?!.*CrOS))/},
          {s: 'iOS', r: /(iPhone|iPad|iPod)/},
          {s: 'Mac OS X', r: /Mac OS X/},
          {s: 'Mac OS', r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
          {s: 'QNX', r: /QNX/},
          {s: 'UNIX', r: /UNIX/},
          {s: 'BeOS', r: /BeOS/},
          {s: 'OS/2', r: /OS\/2/},
          {s: 'Search Bot', r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
        for (let id in clientStrings) {
          let cs = clientStrings[id];
          if (cs.r.test(nAgt)) {
            os = cs.s;
            break;
          }
        }

        let osVersion = unknown;

        if (/Windows/.test(os)) {
          osVersion = /Windows (.*)/.exec(os)[1];
          os = 'Windows';
        }

        switch (os) {
          case 'Mac OS X':
            osVersion = /Mac OS X (10[._\d]+)/.exec(nAgt)[1];
            break;

          case 'Android':
            osVersion = /Android ([._\d]+)/.exec(nAgt)[1];
            break;

          case 'iOS':
            osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nVer);
            osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
            break;
        }

        // // flash (you'll need to include swfobject)
        // /* script src="//ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js" */
        // let flashVersion = 'no check';
        // if (typeof swfobject != 'undefined') {
        //   let fv = swfobject.getFlashPlayerVersion();
        //   if (fv.major > 0) {
        //     flashVersion = fv.major + '.' + fv.minor + ' r' + fv.release;
        //   }
        //   else  {
        //     flashVersion = unknown;
        //   }
        // }

        this.jscd.screen = screenSize;
        this.jscd.browser = browser;
        this.jscd.browserVersion = version;
        this.jscd.browserMajorVersion = majorVersion;
        this.jscd.mobile = mobile;
        this.jscd.os = os;
        this.jscd.osVersion = osVersion;
        this.jscd.cookies = cookieEnabled;
        // this.jscd.flashVersion= flashVersion;


      },

      initialize() {

      },

      login() {
        this.$refs['loginForm'].validate((valid) => {
          if (valid) {
            this.$delegate('gausaka', 'userLogin', {
              username: this.ruleForm.username,
              password: this.ruleForm.password,
              cultureName: this.ruleForm.cultureName,
              clientSystem: this.jscd.os + ' ' + this.jscd.osVersion,
              clientBrowser:  this.jscd.browser + ' ' + this.jscd.browserMajorVersion,
              clientIp: '',
            }).then((res) => {
              this.$store.commit('setSession', res.result);
              this.$router.replace(this.$route.query.redirect || '/');
            }).catch(() => {
            });
          } else {
            this.$notify({
              title: this.$qt('notify.exceptionTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'error'
            });
          }
        });
      },
    },

    beforeRouteEnter(to, from, next) {
      next(vm => vm.initialize());
    }
  };
</script>

<style scoped>
  .login-page {
    text-align: center;
    background-color: #ebebeb;
    width: 300px;
    height: 450px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);

    border-radius: 5px;
  }

  .login-header {
    border-bottom: 1px solid #303133;
    padding: 15px;
    margin-bottom: 25px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }

  .login-form {
    margin: 25px;
  }
</style>
